// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Fechar',
  error: () => 'Erro',
  warn: () => 'Aviso',
  info: () => 'Informações',
  confirmation: () => 'Confirmação',
  progressIndeterminate: () => 'A Decorrer',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenhuma secção correspondente encontrada.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Prima Enter para selecionar o valor.',
  indexer_touchInstructionText: () =>
    'Toque duas vezes e mantenha o toque para entrar no modo de gestos, em seguida, arraste para cima ou para baixo para ajustar o valor.',
  inputPassword_show: () => 'Mostrar Senha',
  inputPassword_hide: () => 'Ocultar Senha',
  inputPassword_hidden: () => 'Senha Oculta',
  formControl_clear: () => 'Limpar',
  formControl_loading: () => 'A Carregar',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Comprimento máximo ' + p['MAX_LENGTH'] + ' excedido.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caracteres em falta.',
  formControl_requiredMessageDetail: () => 'Introduza um valor.',
  select_requiredMessageDetail: () => 'Selecione um valor.',
  select_noMatchesFound: () => 'Não foram encontradas correspondências.',
  select_oneMatchFound: () => 'Foi encontrada uma correspondência',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondências encontradas',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' ou mais correspondências encontradas',
  selectMultiple_selectedValues: () => 'Valores selecionados',
  selectMultiple_showSelectedValues: () => 'Mostrar só valores selecionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores selecionados.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Prima a tecla de retrocesso ou a tecla Delete para retirar o valor selecionado.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Retroceder',
  selector_selected: () => 'Caixa de seleção selecionada',
  selector_unselected: () => 'Caixa de seleção não selecionada',
  userAssistance_learnMore: () => 'Mais informações',
  userAssistance_required: () => 'Obrigatório',
  filePicker_singleFileUploadError: () => 'Carregue um ficheiro de cada vez',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Não é possível carregar ficheiros do tipo ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Não é possível carregar ficheiros do tipo: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'desconhecido',
  filePicker_dropzonePrimaryText: () => 'Arrastar e Largar',
  filePicker_dropzoneSecondaryText: () => 'Selecionar um ficheiro ou largar um aqui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecionar ou largar ficheiros aqui',
  filePicker_addFiles: () => 'Acrescentar Ficheiros',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Aumentar',
  inputNumber_decrease: () => 'Diminuir',
  inputNumber_converterParseError: () => 'Introduza um número.',
  noData_message: () => 'Não existem itens para apresentação',
  message_navigationFromMessagesRegion: () =>
    'A entrar na região de mensagens. Prima F6 para navegar novamente para o elemento anteriormente focado.',
  message_navigationToMessagesRegion: () =>
    'A região das mensagens tem mensagens novas. Prima F6 para navegar para a mais recente região de mensagens.',
  messageToast_allMessagesClosed: () => 'Todas as mensagens de alerta foram fechadas.',
  expandableList_groupCollapse: () => 'Contraído',
  expandableList_groupExpand: () => 'Expandido',
  expandableList_expandCollapseInstructionText: () =>
    'Utilize as teclas de seta para expandir e contrair',
  list_suggestion: () => 'Sugestão',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Passo ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_current: () => 'Atual',
  train_visited: () => 'Visitado',
  train_not_visited: () => 'Não visitado',
  train_message_type: () => 'Tipo de Mensagem',
  viz_drillable: () => 'Passível de definir o nível de detalhe',
  dataVisualization_stateSelected: () => 'Selecionado',
  dataVisualization_stateUnselected: () => 'Não selecionado',
  dataVisualization_noData: () => 'Não existem dados para apresentação'
};
export default bundle;
